import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

export default function DateField({ label, name, value, onChange, required }) {
  return (
    <div className="flex flex-col">
      <label className="mb-1 text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500"> *</span>}
      </label>

      <DatePicker
        calendar={persian}
        locale={persian_fa}
        value={value}
        editable={false}
        inputClass="w-full rounded-lg border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none"
        calendarPosition="bottom-right"
        onChange={(date) =>
          onChange({
            target: {
              name,
              value: date?.format("YYYY/MM/DD") || "",
            },
          })
        }
      />
    </div>
  );
}
